import { Navigate } from "react-router-dom";

import { CampaignsPage } from "./pages/campaigns";
import { CampaignDetailPage } from "./pages/campaigns/detail";
import { CampaignsInquiriesPage } from "./pages/campaigns/inquiries";
import { CampaignsInquiryCreatePage } from "./pages/campaigns/inquiries/create";
import { CampaignInquiryDetailPage } from "./pages/campaigns/inquiries/detail";
import CampaignInquiryDuplicationCampaignPage from "./pages/campaigns/inquiries/duplicate/CampaignInquiryDuplicationCampaignPage";
import CampaignInquiryDuplicationInquiryPage from "./pages/campaigns/inquiries/duplicate/CampaignInquiryDuplicationInquiryPage";
import { DashboardPage } from "./pages/dashboard";
import { DeveloperToolsPage } from "./pages/developer-tools";
import { LoginPage } from "./pages/login";
import { LoginCallbackPage } from "./pages/login/callback";
import { OrganizationPage } from "./pages/organization";
import { PasswordResetPage } from "./pages/passwordReset";
import { ProfilePage } from "./pages/profile";
import { TenantsPage } from "./pages/tenants";
import { TenantDetailPage } from "./pages/tenants/detail";

export const RoutePath = {
    HOME: "/",
    LOGIN: "/login",
    LOGIN_CALLBACK: "/login/callback",
    PASSWORD_RESET: "/password-reset",
    DASHBOARD: "/dashboard",
    PROFILE: "/profile",

    // Campaign routes
    CAMPAIGNS: "/campaigns",
    CAMPAIGN_DETAIL: "/campaign/:campaignId/:tab?/*",
    CAMPAIGNS_INQUIRIES: "/campaigns/inquiries",
    CAMPAIGNS_INQUIRY_CREATE: "/campaigns/inquiry",
    CAMPAIGNS_INQUIRY_CREATE_DUPLICATE_FROM_INQUIRY: "/campaigns/inquiry/duplicate/inquiry/:campaignInquiryId",
    CAMPAIGNS_INQUIRY_CREATE_DUPLICATE_FROM_CAMPAIGN: "/campaigns/inquiry/duplicate/campaign/:campaignId",
    CAMPAIGN_INQUIRY_DETAIL: "/campaigns/inquiry/:campaignInquiryId/:tab?/*",

    // Tenant routes
    TENANTS: "/tenants",
    TENANT_DETAIL: "/tenant/:tenantId/:tab?",

    // Organization routes
    ORGANIZATION: "/organization/:tab?",

    // Developer tools routes
    DEVELOPER_TOOLS: "/developer-tools",
} as const;

export type RoutePath = (typeof RoutePath)[keyof typeof RoutePath];

export interface RouteParams {
    [RoutePath.CAMPAIGN_DETAIL]: { campaignId: string; tab?: string };
    [RoutePath.CAMPAIGNS_INQUIRY_CREATE_DUPLICATE_FROM_INQUIRY]: { campaignInquiryId: string };
    [RoutePath.CAMPAIGNS_INQUIRY_CREATE_DUPLICATE_FROM_CAMPAIGN]: { campaignId: string };
    [RoutePath.CAMPAIGN_INQUIRY_DETAIL]: { campaignInquiryId: string };
    [RoutePath.TENANT_DETAIL]: { tenantId: string; tab?: string };
    [RoutePath.ORGANIZATION]: { tab?: string };
}

export interface RouteConfig {
    path: RoutePath;
    element: React.ReactNode;
}

export const publicRoutes: readonly RouteConfig[] = [
    {
        path: RoutePath.HOME,
        element: <Navigate to={RoutePath.CAMPAIGNS} replace />,
    },
    {
        path: RoutePath.LOGIN,
        element: <LoginPage />,
    },
    {
        path: RoutePath.LOGIN_CALLBACK,
        element: <LoginCallbackPage />,
    },
    {
        path: RoutePath.PASSWORD_RESET,
        element: <PasswordResetPage />,
    },
    {
        path: RoutePath.DASHBOARD,
        element: <DashboardPage />,
    },
    {
        path: RoutePath.PROFILE,
        element: <ProfilePage />,
    },

    // Campaign routes
    {
        path: RoutePath.CAMPAIGNS,
        element: <CampaignsPage />,
    },
    {
        path: RoutePath.CAMPAIGN_DETAIL,
        element: <CampaignDetailPage />,
    },
    {
        path: RoutePath.CAMPAIGNS_INQUIRIES,
        element: <CampaignsInquiriesPage />,
    },
    {
        path: RoutePath.CAMPAIGNS_INQUIRY_CREATE,
        element: <CampaignsInquiryCreatePage />,
    },
    {
        path: RoutePath.CAMPAIGNS_INQUIRY_CREATE_DUPLICATE_FROM_INQUIRY,
        element: <CampaignInquiryDuplicationInquiryPage />,
    },
    {
        path: RoutePath.CAMPAIGNS_INQUIRY_CREATE_DUPLICATE_FROM_CAMPAIGN,
        element: <CampaignInquiryDuplicationCampaignPage />,
    },
    {
        path: RoutePath.CAMPAIGN_INQUIRY_DETAIL,
        element: <CampaignInquiryDetailPage />,
    },

    // Tenant routes
    {
        path: RoutePath.TENANTS,
        element: <TenantsPage />,
    },
    {
        path: RoutePath.TENANT_DETAIL,
        element: <TenantDetailPage />,
    },

    // Organization routes
    {
        path: RoutePath.ORGANIZATION,
        element: <OrganizationPage />,
    },

    // Developer tools routes
    {
        path: RoutePath.DEVELOPER_TOOLS,
        element: <DeveloperToolsPage />,
    },
] as const;
